"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreMockUtils = void 0;
const api_shared_1 = require("@smallstack/api-shared");
const uuid_1 = require("uuid");
/**
 * Can be used to test stores without preconfigured cloud api clients
 */
class StoreMockUtils {
    /**
     * adds simple mocked implementations for all CRUD related operations like create, read, update and delete
     */
    static mockPageableCrudStore(store, initialValues) {
        if (initialValues)
            store.setValue(initialValues);
        store["loadModels"] = () => Promise.resolve((0, api_shared_1.createPageFrom)([]));
        store["loadModelById"] = (id) => Promise.resolve();
        store["deleteModelById"] = (id) => Promise.resolve();
        store["createModel"] = (model) => {
            if (model.id === undefined)
                model.id = (0, uuid_1.v4)();
            return Promise.resolve(model);
        };
        store["patchModel"] = (id, model) => {
            const savedModel = store.getById(id);
            return Promise.resolve(Object.assign({}, savedModel, model));
        };
        store["putModel"] = (model) => Promise.resolve(model);
    }
}
exports.StoreMockUtils = StoreMockUtils;
